function initGleenAI() {
  function sendGleenEvent(eventName, payload) {
    if (window.Shopify) {
      payload.deviceType = findDeviceType();
      const data = {
        payload,
        eventName,
      };
      window.Shopify.analytics.publish("mp:gleen-events", data);
    }
  }

  // Add to Cart
  window.gleenWidget.on("products:added_to_cart", function (data) {
    if (data && data.length) {
      var productInfoList = [];
      var totalCartValue = 0;
      data.forEach(function (item) {
        var prodInfo = {
          productname: item.productName ? item.productName : "",
          sku: item.variantId ? item.variantId : "",
          price: item.price ? item.price : "",
          quantity: item.quantity ? item.quantity : "",
          variant:
            item.attributes && item.attributes.size ? item.attributes.size : "",
          category: item.category ? item.category : "",
          brand: "Tatcha",
          position: item.position ? item.position : 1,
          couponCode: "",
          masterSku: item.masterProductId ? item.masterProductId : "",
          type: "",
        };
        productInfoList.push(prodInfo);

        var price = item.price.replace("$", "").trim();
        var priceVal = parseFloat(price);
        totalCartValue += priceVal * item.quantity;

        if (item.quantity && item.quantity > 0) {
          item.prid = item.variantId + "|" + item.quantity;
        }
      });

      if (
        window.gleenWidget &&
        window.gleenWidget.close &&
        typeof window.gleenWidget.close === "function"
      ) {
        window.gleenWidget.close();
      }

      var customAttributes = {
        siteSection: "Gleen AI Widget",
        sourcePage: window.location.href,
        pagePath: window.location.pathname,
        deviceType: window.findDeviceType(),
        utm_source: "",
        utm_campaign: "",
        utm_medium: "",
      };
      customAttributes.totalCartValue = totalCartValue ? totalCartValue : 0;

      sendGleenEvent("GleenWidget:bot_response_finished", {
        productInfoList,
        customAttributes,
      });
    }
  });

  window.gleenWidget.on("widget:opened", function () {
    var data = {};
    data.pagePath = window.location.pathname;
    sendGleenEvent("GleenWidget:opened", data, "Gleen AI");
  });

  window.gleenWidget.on("ticket:email_submitted", function (data) {
    data.pagePath = window.location.pathname;
    sendGleenEvent("GleenWidget:email_submitted", data);
  });

  window.gleenWidget.on("ticket:message_submitted", function (data) {
    data.pagePath = window.location.pathname;
    sendGleenEvent("GleenWidget:message_submitted", data);
  });

  window.gleenWidget.on("ticket:bot_response_finished", function (data) {
    data.pagePath = window.location.pathname;
    sendGleenEvent("GleenWidget:bot_response_finished", data);
  });

  window.gleenWidget.on("product:page_opened", function (data) {
    data.pagePath = window.location.pathname;
    sendGleenEvent("GleenWidget:product:page_opened", data);
  });

  window.gleenWidget.on("product:displayed", function (data) {
    data.pagePath = window.location.pathname;
    sendGleenEvent("GleenWidget:product:displayed", data);
  });
}

var gleenWidgetInterval = setInterval(function () {
  if (window.gleenWidget) {
    clearInterval(gleenWidgetInterval);
    initGleenAI();
  }
}, 50);
